export type SocialWallFeedErrorKind = "token" | "generic";

const TOKEN_ERROR_PATTERNS = [
  /error validating access token/i,
  /session has been invalidated/i,
  /session has expired/i,
  /access token .* expired/i,
  /token.*(expired|invalid|invalidated)/i,
  /oauthexception/i,
  /invalid oauth/i,
  /\(#190\)/,
  /user changed their password/i,
  /facebook has changed the session/i,
  /the user is enrolled in a blocking/i,
];

export function classifySocialWallFeedError(
  message: string | null | undefined
): SocialWallFeedErrorKind {
  const text = String(message || "").trim();
  if (!text) return "generic";
  if (TOKEN_ERROR_PATTERNS.some((pattern) => pattern.test(text))) {
    return "token";
  }
  return "generic";
}

export function extractSocialWallFeedErrorMessage(error: unknown): string {
  const fromResponse = (error as {
    response?: { data?: { message?: string; error?: string } };
    message?: string;
  })?.response?.data;

  return (
    fromResponse?.message ||
    fromResponse?.error ||
    (error as { message?: string })?.message ||
    ""
  );
}
